import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import React, { useEffect } from "react";

interface MembershipPermissionProps {
  children: JSX.Element;
  requiredPermission: string;
}

const MembershipPermission: React.FC<MembershipPermissionProps> = ({
  children,
  requiredPermission,
}) => {
  const navigate = useNavigate();
  const { organizationData } = useSelector(
    (state) => state.entities.organization
  );
  const { membershipData } = useSelector((state) => state.entities.membership);

  useEffect(() => {
    if (organizationData && organizationData?.membership_id) {
      const { permissions } = membershipData ?? { permissions: {} };

      const hasRequiredPermission = permissions[requiredPermission] ?? false;

      if (membershipData && !hasRequiredPermission) {
        navigate("/unauthorized");
      }
    }
  }, [organizationData, membershipData, navigate]);

  return organizationData && children;
};

export default MembershipPermission;
